import { Button } from '@polichat/flamboyant';
import { useCallback } from 'react';
import { Info } from '@poli-digital/react';
import getUrlViewCrm from '../../../../../components/tools/integrations/crmRequests/getUrlViewCrm';
import { useWhiteLabel } from 'src/hooks/useWhiteLabel';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';
import { generateWhatsAppLink } from 'src/utils/whatsappLink';

function ValidationPage(props) {
  const isWL = useWhiteLabel().isWl;
  const hasCrm = props?.permissions?.customerPermission;
  const hasPermission = props?.permissions?.userPermission;
  const urlWhatsapp = generateWhatsAppLink('spa.common.whatsapp.wantToKnowFlow');
  const opportunitiesAndTicketsText = useGlotaT('spa.details.crm.opportunitiesAndTickets');
  const scheduleMessagesText = useGlotaT('spa.details.crm.scheduleMessages');
  const knowFeaturesText = useGlotaT('spa.details.crm.knowFeatures');
  const wantToKnowFlowText = useGlotaT('spa.details.crm.wantToKnowFlow');
  const startUsingFlowText = useGlotaT('spa.details.crm.startUsingFlow');
  const featuresEnabledText = useGlotaT('spa.details.crm.featuresEnabled');
  const useFlowText = useGlotaT('spa.details.crm.useFlow');
  const redirectToAddCrmClient = useCallback(() => {
    window.location.href = urlWhatsapp;
  }, [urlWhatsapp]);

  const getUrl = async () => {
    const response = await getUrlViewCrm();

    if (response && response.data) {
      return response.data;
    }
  };
  const getFlowUrl = useCallback(async () => {
    const url = await getUrl();
    window.location.href = url;
  }, []);

  if (!hasCrm && !isWL) {
    return (
      <>
        <span>
          <strong>{opportunitiesAndTicketsText}</strong>
        </span>
        <div>
          <span dangerouslySetInnerHTML={{ __html: scheduleMessagesText }} />
          <br />
          <br />
          <span>{knowFeaturesText}</span>
          <Button className="btn-new-crm" onClick={redirectToAddCrmClient}>
            {wantToKnowFlowText}
          </Button>
        </div>
      </>
    );
  }

  if (!hasPermission && !isWL) {
    return (
      <>
        <h>
          <strong>{opportunitiesAndTicketsText}</strong>
        </h>
        <div className="info-user-crm">
          <span>
            <Info /> <strong>{startUsingFlowText}</strong>
          </span>
          <br />
          <span>
            {featuresEnabledText}
          </span>
          <Button
            className="btn-new-crm"
            onClick={() => getFlowUrl()}
          >
            {useFlowText}
          </Button>
        </div>
      </>
    );
  }

  return <></>;
}

export default ValidationPage;
